import React from 'react';
import useEditorStore from '../../stores/useEditorStore';
import { useShallow } from 'zustand/shallow';

const EraserToolCard = () => {
  const [eraserMode, setToolSetting] = useEditorStore(
    useShallow((state) => [
      state.toolSettings.scan_preparing_eraser?.mode || 'withdraw',
      state.setToolSetting
    ])
  );

  const modes = [
    { id: 'withdraw', label: 'Withdraw', icon: '/tool_icons/scan_preparing_eraser_invert.png' },
    { id: 'unselect', label: 'Unselect', icon: '/tool_icons/scan_preparing_eraser_unselect.png' }
  ];

  return (
    <div style={{
      position: 'absolute',
      top: '10px',
      left: '10px',
      background: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      minWidth: '200px',
      zIndex: 1000
    }}>


      {/* Mode Selection Buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
        {modes.map((mode) => (
          <button
            key={mode.id}
            onClick={() => setToolSetting('scan_preparing_eraser', 'mode', mode.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              border: '1px solid #7c3aed',
              borderRadius: '6px',
              background: eraserMode === mode.id ? '#7c3aed' : '#fff',
              color: eraserMode === mode.id ? '#fff' : '#7c3aed',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.2s ease',
              width: '100%',
              textAlign: 'left'
            }}
            onMouseOver={(e) => {
              if (eraserMode !== mode.id) {
                e.target.style.background = '#f9fafb';
                e.target.style.borderColor = '#d1d5db';
              }
            }}
            onMouseOut={(e) => {
              if (eraserMode !== mode.id) {
                e.target.style.background = '#fff';
                e.target.style.borderColor = '#e5e7eb';
              }
            }}
          >
            <img 
              src={mode.icon} 
              alt={mode.label}
              style={{ 
                width: '20px', 
                height: '20px', 
                marginRight: '12px',
                filter: eraserMode === mode.id ? 'brightness(0) invert(1)' : 'none'
              }}
            />
            {mode.label}
          </button>
        ))}
      </div>




    </div>
  );
};

export default EraserToolCard; 